var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmployeeAccountIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5621088D-6D7C-490B-8C76-0F15E0CE76C7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-info",
    transform: "translate(-132.000000, -247.000000)",
    fill: "#00142D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-291",
    transform: "translate(132.000000, 247.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.82608696,5.45444628 C9.26434783,5.45444628 10.4347826,4.23083217 10.4347826,2.72722314 C10.4347826,1.22361412 9.26434783,0 7.82608696,0 C6.38782609,0 5.2173913,1.22361412 5.2173913,2.72722314 C5.2173913,4.23083217 6.38782609,5.45444628 7.82608696,5.45444628",
    id: "Fill-3135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9130435,5.45444628 C14.8721739,5.45444628 15.6521739,4.63900656 15.6521739,3.63629752 C15.6521739,2.63267941 14.8721739,1.81814876 13.9130435,1.81814876 C12.953913,1.81814876 12.173913,2.63267941 12.173913,3.63629752 C12.173913,4.63900656 12.953913,5.45444628 13.9130435,5.45444628",
    id: "Fill-3136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73913043,5.45444628 C2.69826087,5.45444628 3.47826087,4.63900656 3.47826087,3.63629752 C3.47826087,2.63267941 2.69826087,1.81814876 1.73913043,1.81814876 C0.78,1.81814876 0,2.63267941 0,3.63629752 C0,4.63900656 0.78,5.45444628 1.73913043,5.45444628",
    id: "Fill-3137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.434782609,13.6361157 L3.04347826,13.6361157 C3.28347826,13.6361157 3.47826087,13.432483 3.47826087,13.1815785 L3.47826087,8.18166942 C3.47826087,7.17805131 2.69826087,6.36352066 1.73913043,6.36352066 C0.78,6.36352066 0,7.17805131 0,8.18166942 L0,13.1815785 C0,13.432483 0.194782609,13.6361157 0.434782609,13.6361157",
    id: "Fill-3138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6086957,13.6361157 L15.2173913,13.6361157 C15.4573913,13.6361157 15.6521739,13.432483 15.6521739,13.1815785 L15.6521739,8.18166942 C15.6521739,7.17805131 14.8721739,6.36352066 13.9130435,6.36352066 C12.953913,6.36352066 12.173913,7.17805131 12.173913,8.18166942 L12.173913,13.1815785 C12.173913,13.432483 12.3686957,13.6361157 12.6086957,13.6361157",
    id: "Fill-3139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65217391,15.4542645 L10,15.4542645 C10.24,15.4542645 10.4347826,15.2506318 10.4347826,14.9997273 L10.4347826,9.0907438 C10.4347826,7.58713478 9.26434783,6.36352066 7.82608696,6.36352066 C6.38782609,6.36352066 5.2173913,7.58713478 5.2173913,9.0907438 L5.2173913,14.9997273 C5.2173913,15.2506318 5.41217391,15.4542645 5.65217391,15.4542645",
    id: "Fill-3140"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmployeeAccountIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/employeeAccount_icon.424e29fd4d76ce02e0014a1046a5bcf4.svg";